import React,{Fragment} from "react";
import {Avatar} from "@material-ui/core";
import "./Header.css";
import {CgMenuGridR} from "react-icons/cg";

const Header =(props)=>{
    return(
        <Fragment>
             <header id="header" className="main_header_container flex-row">
                <nav className="header_nav flex-row">
                    <ul className="header_ul_left desktop-only flex-row">
                        <li >About</li>
                        <li>Store</li>
                    </ul>
                    <ul className="header_ul_right flex-row">
                        <li>Gmail</li>
                        <li>Images</li>
                        <li className="grid-link"><CgMenuGridR/></li>
                        <li><Avatar src="" alt="profile" className="header_avatar" /></li>
                    </ul>
                </nav>
            </header> 
        </Fragment>
      
    )
}
export default Header;